/* src/app/modules/print-cards/components/cards/backgrounds/post-cards-4x6/fire-and-flower-shelf-talker-post-card-background/fire-and-flower-shelf-talker-post-card-background.component.scss */
:host {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: stretch;
  box-sizing: border-box;
}
:host .main-content {
  flex: 1;
}
:host .main-content .print-card-background-asset {
  height: 100%;
  width: 100%;
}
/*# sourceMappingURL=fire-and-flower-shelf-talker-post-card-background.component.css.map */
